import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkMode = new BehaviorSubject<boolean>(false);
  public isDarkMode$ = this.isDarkMode.asObservable();

  constructor() {
    // Always use light mode - Printzell Print Portal uses light theme only
    this.enableLightMode();
  }

  toggleTheme(): void {
    if (this.isDarkMode.value) {
      this.enableLightMode();
    } else {
      this.enableDarkMode();
    }
  }

  enableDarkMode(): void {
    document.documentElement.classList.add('p-dark');
    localStorage.setItem('theme-mode', 'dark');
    this.isDarkMode.next(true);
  }

  enableLightMode(): void {
    document.documentElement.classList.remove('p-dark');
    localStorage.setItem('theme-mode', 'light');
    this.isDarkMode.next(false);
  }

  getCurrentTheme(): 'light' | 'dark' {
    return this.isDarkMode.value ? 'dark' : 'light';
  }
}